var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFastapiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 2500,
    width: 2500,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 154 154",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 77,
    cy: 77,
    fill: "#05998b",
    r: 77
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.375 18.667l-38.75 70H77.5l-3.875 46.666 38.75-70H77.5z",
    fill: "#fff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastapiLogo);
export default __webpack_public_path__ + "static/media/fastapi_logo.6c84dc4ea9626837be0ce2c5523b6d52.svg";
export { ForwardRef as ReactComponent };